<template>
  <div>
    <vxe-grid
      ref="table"
      size="small"
      row-id="hxJdOrderDetilCode"
      cell-class-name="align-top"
      resizable
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="780"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :footer-method="() => footerData"
      show-footer
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:toolbar_btn>
        <slot name="toolbar_btn"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="row.defaultImageUrl || '/image/static/img/nopic-square.jpg'"
          :preview-src-list="[
            row.defaultImageUrl || '/image/static/img/nopic-square.jpg',
          ]"
          style="width:60px; height:60px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic-square.jpg"
              style="width:60px; height:60px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:displayName="{ row }">
        <TableLabel :value="row.goodsName" />
        <TableLabel :value="row.goodsNameEn" />
        <TableLabel
          :label="$l('table_label_goodsSize') || 'SIZE'"
          :value="row.goodsSize"
        />
        <TableLabel
          :label="$l('table_label_goodsColor') || 'COLOR'"
          :value="[row.goodsColor, row.goodsColorEn].filter(Boolean).join(' ')"
        />
      </template>
      <template v-slot:displayNo="{ row }">
        <TableLabel :label="'SKU'" :value="row.hxSkuNo" />
        <TableLabel :label="'NC'" :value="row.ncNo" />
        <TableLabel
          :label="$l('table_label_jdItemNo') || 'ITEM#'"
          :value="row.jdItemNo"
        />
        <TableLabel
          :label="$l('table_label_jdUpcNo') || 'UPC#'"
          :value="row.jdUpcNo"
        />
      </template>
      <template v-slot:displayOrder="{ row }">
        <TableLabel
          :label="$l('table_label_hxJdOrderNo') || '订单号'"
          :value="row.hxJdOrderNo"
        />
        <TableLabel :label="$l('table_label_jdDc') || 'DC'" :value="row.jdDc" />
        <TableLabel :label="$l('table_label_jdWh') || 'WH'" :value="row.jdWh" />
      </template>
      <template v-slot:procureBoxes="{ row }">
        <TableLabel
          :label="'整箱'"
          :value="divideDown(row.originalQty, row.hxInCtnQty,0).toString()"
        />
        <TableLabel
          :label="'尾箱'"
          :value="mod(row.originalQty, row.hxInCtnQty) > 0 ? '1' : '0'"
        />
        <br />
        <TableLabel
          :label="'总箱'"
          :value="
            mod(row.originalQty, row.hxInCtnQty) > 0
              ? (divideDown(row.originalQty, row.hxInCtnQty,0) + 1).toString()
              : divideDown(row.originalQty, row.hxInCtnQty,0).toString()
          "
        />
      </template>
      <template v-slot:fclCtnQty="{ row }">
        <TableLabel :label="'整箱'" :value="row.fclCtnQty.toString()" />
        <TableLabel :label="'尾箱'" :value="row.tailCtnQty.toString()" />
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
import TableLabel from './label.vue'
import { format, multiply, divide, divideDown,mod, add } from '@/libs/util.number.js'
export default {
  components: { TableLabel },
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form', tools: 'toolbar_btn' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      format: (n) => format(n),
      multiply: (x, y) => multiply(x, y),
      divide: (x, y) => divide(x, y),
      mod: (x, y) => mod(x, y),
      divideDown: (x, y,z) => divideDown(x, y,z),
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    footerData() {
      const totalColumnFields = this.tableColumns
        .filter((c) => c.isTotalColumn)
        .map((c) => c.field)

      const totalColumnValues = this.tableData.reduce((result, next) => {
        totalColumnFields.forEach((f) => {
          result[f] = add(result[f], next[f])
        })
        return result
      }, Object.fromEntries(totalColumnFields.map((f) => [f, 0])))

      const result = this.tableColumns
        .filter((c) => c.visible != false)
        .map((t) => {
          const val = totalColumnValues[t.field]
          return val ? format(val) : ''
        })
      result[0] = this.$l('INDEX.total') || '合计'
      return [result]
    },
  },
}
</script>
